import { render, staticRenderFns } from "./RecognitionItem.vue?vue&type=template&id=bcfd3118&scoped=true"
import script from "./RecognitionItem.vue?vue&type=script&lang=js"
export * from "./RecognitionItem.vue?vue&type=script&lang=js"
import style0 from "./RecognitionItem.vue?vue&type=style&index=0&id=bcfd3118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfd3118",
  null
  
)

export default component.exports